<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">{{ $t('field.recode') }}</div>
                <input
                  v-model="searchParams.recode"
                  type="text"
                  :disabled="disableRecode"
                />
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">{{ $t('field.operation') }}</div>
                <el-select
                  v-model="searchParams.operationType"
                  :disabled="disabledAllFieldsExceptRecode"
                >
                  <!-- filterable -->
                  <el-option label="Tạo" :value="1" />
                  <el-option label="Ghi đè" :value="2" />
                </el-select>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">{{ 'Khoảng ngày' }}</div>
                <CalendarRange
                  v-model="searchParams.createDate"
                  mode="date"
                  :disabled="disabledAllFieldsExceptRecode"
                  @input="onDatePickerChange"
                />
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">{{ $t('field.receptionist') }}</div>
                <select-with-search-table
                  style="width: 100%"
                  index-field="id"
                  :search-fields="['code', 'name']"
                  :selected-index-field-value="searchParams.receptionistId"
                  :value="searchParams.receptionistId"
                  :rows="receptionistRows"
                  :columns="receptionistCols"
                  :dropdown-width="400"
                  :is-remove-btn="true"
                  :disabled="disabledAllFieldsExceptRecode"
                  @selectionChanged="onSelectReceptionist"
                >
                  <template v-slot:value="{ selectedValue: selectedData }">
                    <div>
                      <span>
                        {{
                          `${selectedData?.code || ''} - ${
                            selectedData?.full_name || ''
                          }`
                        }}
                      </span>
                    </div>
                  </template>
                </select-with-search-table>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">{{ $t('field.hotel') }}</div>
                <el-select
                  v-model="searchParams.hotelIds"
                  multiple
                  collapse-tags
                  filterable
                  clearable
                  :disabled="disabledAllFieldsExceptRecode"
                >
                  <el-option
                    v-for="item in hotelOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
                <!-- <Multiselect
                  v-model="searchParams.hotel"
                  :options="hotelOptions"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder=""
                  label="name"
                  track-by="id"
                  :preselect-first="true"
                >
                  <template
                    slot="selection"
                    slot-scope="{ values, search, isOpen }"
                  >
                    <span
                      v-if="values.length"
                      v-show="!isOpen"
                      class="Multiselect__single"
                    >
                      {{ values.length }} options selected
                    </span>
                  </template>
                </Multiselect> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">
                {{ $t('views.report.creatingSmartKeyReport') }}
              </span>
            </div>
            <div class="flex" style="gap: 10px">
              <InfoBtn @click="noteDialogVisible = true" />

              <el-dropdown trigger="click" @command="onClickDropdownItem">
                <das-button
                  color="primary"
                  size="medium"
                  :rounded="false"
                  outline
                  icon
                >
                  <i class="el-icon-download"></i>
                </das-button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">
                    {{ $t('button.exportPdf') }}
                  </el-dropdown-item>
                  <el-dropdown-item command="excel">
                    {{ $t('button.exportExcel') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <hr />

          <div class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              :auto-size-cell="true"
              dom-layout="scroll"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('dialog.titleNote')"
      :visible.sync="noteDialogVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Số thứ tự: Hiển thị số thứ tự</li>
            <li>Recode: Mã đặt phòng</li>
            <li>Phòng: Hiển thị tên phòng và tên hạng phòng</li>
            <li>Ngày Checkin: Hiển thị ngày khách checkin</li>
            <li>Ngày Checkout: Hiển thị thời gian khách checkout</li>
            <li>Ngày giờ thao tác: Thời gian nhân viên thao tác với thẻ</li>
            <li>
              Thao tác: Hiển thị thao tác nhân viên thực hiện : ghi đè/ tạo mới
              thẻ
            </li>
            <li>
              Lễ tân: hiển thị họ và tên nhân viên lễ tân thực hiện thao tác
            </li>
            <li>Mã khóa từ: là mã ID của thẻ</li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="noteDialogVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DasButton from '@/components/ui/DasButton.vue'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import InfoBtn from './components/InfoBtn.vue'

import bus from '@/utils/bus'
import { getAccount } from '@/api/reception/common'
import { getAllHotel } from '@/api/hotel.js'
import {
  getCreateCardRoomReport,
  getCreateCardRoomReportExcel
} from '@/api/report_service/datntReport'
import _ from 'lodash'
import { downloadFile } from '@/utils/file-handler'

export default {
  components: {
    DasButton,
    CalendarRange,
    InfoBtn
  },
  data() {
    return {
      noteDialogVisible: false,
      searchParams: {
        recode: null,
        operationType: null,
        receptionistId: null,
        createDate: {
          start: this.$moment().format('YYYY-MM-DD'),
          end: this.$moment().format('YYYY-MM-DD')
        },
        createDateFrom: null,
        createDateTo: null,
        hotelIds: []
      },
      defaultSearchParams: {
        recode: null,
        operationType: null,
        receptionistId: null,
        createDate: {
          start: this.$moment().format('YYYY-MM-DD'),
          end: this.$moment().format('YYYY-MM-DD')
        },
        createDateFrom: null,
        createDateTo: null,
        hotelIds: []
      },

      // input
      disableRecode: false,
      disableDate: false,

      hotelOptions: [],
      receptionistRows: [],
      receptionistCols: [
        {
          headerName: 'Tên',
          field: 'full_name',
          minWidth: 120,
          maxWidth: 150
        },
        {
          headerName: 'Code',
          field: 'code',
          // tooltipFiled: 'desc',
          flex: 1
        }
      ],

      columns: [
        {
          headerName: this.$t('grid.column.numericalOrder'),
          field: 'num',
          // cellClass: "grid-cell-centered",
          minWidth: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.recode'),
          field: 'recode',
          // cellClass: "grid-cell-centered",
          minWidth: 130,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.room'),
          field: 'room_num',
          tooltipField: 'room_num',
          // cellClass: "grid-cell-centered",
          minWidth: 180,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.checkinDate'),
          field: 'check_in_date',
          // cellClass: "grid-cell-centered",
          minWidth: 120,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.checkoutDate'),
          field: 'check_out_date',
          // cellClass: "grid-cell-centered",
          minWidth: 150,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.operationDateTime'),
          field: 'create_date',
          // cellClass: "grid-cell-centered",
          minWidth: 200,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.operation'),
          field: 'operation_type',
          valueGetter: params =>
            params.data.operation_type === 1 ? 'Tạo' : 'Ghi đè',
          // cellClass: "grid-cell-centered",
          minWidth: 150,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.receptionist'),
          field: 'create_user_name',
          // cellClass: "grid-cell-centered",
          minWidth: 200,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.smartKeyCode'),
          field: 'card_number',
          // cellClass: "grid-cell-centered",
          minWidth: 140,
          sortable: false
        }
      ],
      rows: []
    }
  },

  computed: {
    disabledAllFieldsExceptRecode() {
      return !!this.searchParams.recode
    }
  },

  watch: {
    'searchParams.recode'(nv, ov) {
      if (nv) {
        this.searchParams = {
          ...this.searchParams,
          ..._.omit(this.defaultSearchParams, ['recode']),
          createDate: {
            end: null,
            start: null
          }
        }
        this.disableDate = true
      } else {
        this.disableDate = false
      }
    }
  },

  beforeMount() {},
  async mounted() {
    this.getHotelOptions()
    await this.getListReceptionist()
    await this.fnGetCreateCardRoomReport()
  },
  methods: {
    onSearch() {
      this.fnGetCreateCardRoomReport()
    },
    onReset() {
      this.searchParams = { ...this.defaultSearchParams }
      this.disableRecode = false
      this.disableDate = false
      this.fnGetCreateCardRoomReport()
    },

    onDatePickerChange() {
      // console.log(this.searchParams.date)
      if (
        this.searchParams.createDate.end ||
        this.searchParams.createDate.start
      ) {
        this.disableRecode = true
      } else {
        this.disableRecode = false
      }
    },

    // SELECT OPTIONS
    onClickDropdownItem(cmd) {
      if (cmd === 'excel') {
        this.fnDownloadExcel()
      }
      // this.$message('click on item ' + cmd)
    },
    onSelectReceptionist(selected) {
      this.searchParams.receptionistId = selected?.id
    },

    // handle api call
    async fnGetCreateCardRoomReport() {
      try {
        const query = {
          recode: this.searchParams.recode,
          operationType: this.searchParams.operationType,
          receptionistId: this.searchParams.receptionistId,
          createDateFrom: this.searchParams.createDate.start,
          createDateTo: this.searchParams.createDate.end,
          hotelIds: this.searchParams.hotelIds
        }
        const res = await getCreateCardRoomReport(query)
        this.rows = res.data
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.' + error?.response?.data?.message
              ? error?.response?.data?.message
              : error
          )
        })
      } finally {
        //
      }
    },

    async fnDownloadExcel() {
      const query = {
        recode: this.searchParams.recode,
        operationType: this.searchParams.operationType,
        receptionistId: this.searchParams.receptionistId,
        createDateFrom: this.searchParams.createDate.start,
        createDateTo: this.searchParams.createDate.end,
        hotelIds: this.searchParams.hotelIds
      }
      await getCreateCardRoomReportExcel(query)
        .then(res => {
          downloadFile(res, 'bao_cao_tao_khoa_tu.xlsx')
        })
        .catch(error => {
          const msg = error.response.data
          this.$message({
            message: this.$t(msg),
            type: 'error'
          })
        })
      bus.$emit('endLoader')
    },

    async getListReceptionist() {
      // Le tan
      const res = await getAccount({ department: 'FO' })
      this.receptionistRows = res.data.map(item => {
        return {
          id: item.account.id,
          code: item.account.code,
          full_name: item.account.full_name
        }
      })
    },
    getHotelOptions() {
      getAllHotel().then(res => {
        this.hotelOptions = res.data
      })
    }
  }
}
</script>

<style></style>
